import { Form } from 'antd';
import { useEffect, useState } from 'react';
import { Api } from 'services/api';
import { ChangePlan } from 'services/auth.service';
import { GetPlans, GetPromo, PlansResponse, Promo } from 'services/subscription.service';

// TODO: This code is getting repeated multiple times, it could and should be refactored!
export function usePromo() {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>();
  const [data, setData] = useState<Promo>();

  const load = async () => {
    setLoading(true);
    await Api.tryCatch(
      GetPromo(),
      (rs) => {
        setLoading(false);
        setData(rs);
      },
      (err) => {
        setLoading(false);
        setError(err.message);
      },
    );
  };

  let cancelToken = Api.getCancelTokenSource();
  useEffect(() => {
    cancelToken = Api.getCancelTokenSource();
    return () => {
      cancelToken.cancel();
    };
  }, []);

  useEffect(() => {
    load();
  }, []);

  return { loading, error, data };
}

export function usePlans() {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>();
  const [data, setData] = useState<PlansResponse[]>();

  const load = async () => {
    setLoading(true);
    await Api.tryCatch(
      GetPlans(),
      (rs) => {
        setLoading(false);
        setData(rs);
      },
      (err) => {
        setLoading(false);
        setError(err.message);
      },
    );
  };

  let cancelToken = Api.getCancelTokenSource();
  useEffect(() => {
    cancelToken = Api.getCancelTokenSource();
    return () => {
      cancelToken.cancel();
    };
  }, []);

  useEffect(() => {
    load();
  }, []);

  return { loading, error, data, reloadList: load };
}

export function useSavePlanChange() {
  const [isSaving, setIsSaving] = useState(false);
  const [form] = Form.useForm();

  const save = async (code: string) => {
    setIsSaving(true);
    try {
      return await ChangePlan(code);
    } finally {
      setIsSaving(false);
    }
  };

  return { isSaving, save, form };
}
